import isString from 'lodash-es/isString';

import { AtiraLink } from '../../model/atira-link/AtiraLink';
import { CreateAtiraLinkDto } from '../../model/atira-link/dto/CreateAtiraLinkDto';
import { EditAtiraLinkDto } from '../../model/atira-link/dto/EditAtiraLinkDto';
import { GenericWithUserId } from '../../model/shared/GenericWithUserId';
import { GetThemesResponseDto } from '../../model/theme/dto/GetThemesResponseDto';
import { DeleteAtiraLinkDto } from '../../redux/atira-link/dto/DeleteAtiraLinkDto';
import { GenericDisableEnableAtiraLinkDto } from '../../redux/atira-link/dto/GenericDisableEnableAtiraLinkDto';
import { GetThemesDto } from '../../redux/atira-link/dto/GetThemesDto';
import { AtiraApi } from '../AxiosClient';

export class AtiraLinkAxios {
  static async createAtiraLink(dto: CreateAtiraLinkDto) {
    const formData = new FormData();

    Object.entries(dto).forEach(([key, value]) => {
      const isImageKey = ['image', 'ogImage'].includes(key);
      if (isImageKey) {
        formData.append(key, value === null ? 'null' : value);
      } else if (key === 'styles') {
        formData.append(key, isString(value) ? value : JSON.stringify(value));
        formData.append(
          'backgroundImage',
          value.backgroundImage === null ? 'null' : value.backgroundImage,
        );
      } else {
        formData.append(key, isString(value) ? value : JSON.stringify(value));
      }
    });

    return AtiraApi.post<AtiraLink>('/atira-link/create', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(({ data }) => data);
  }

  static async editAtiraLinkDto(dto: EditAtiraLinkDto) {
    const formData = new FormData();

    Object.entries(dto).forEach(([key, value]) => {
      const isImageKey = ['image', 'ogImage'].includes(key);
      if (isImageKey) {
        formData.append(key, value === null ? 'null' : value);
      } else if (key === 'styles') {
        formData.append(key, isString(value) ? value : JSON.stringify(value));
        formData.append(
          'backgroundImage',
          value.backgroundImage === null ? 'null' : value.backgroundImage,
        );
      } else {
        formData.append(key, isString(value) ? value : JSON.stringify(value));
      }
    });

    return AtiraApi.patch<void>(
      `/atira-link/${dto.atiraLinkId}/edit`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    ).then(({ data }) => data);
  }

  static getUserAtiraLinks(dto: GenericWithUserId) {
    return AtiraApi.post(`/atira-link/get`, dto).then(({ data }) => data);
  }

  static deleteAtiraLink(dto: DeleteAtiraLinkDto) {
    return AtiraApi.post(`/atira-link/delete`, dto).then(({ data }) => data);
  }

  static disableAtiraLink(dto: GenericDisableEnableAtiraLinkDto) {
    return AtiraApi.post(`/atira-link/disable`, dto).then(({ data }) => data);
  }

  static enableAtiraLink(dto: GenericDisableEnableAtiraLinkDto) {
    return AtiraApi.post(`/atira-link/enable`, dto).then(({ data }) => data);
  }

  static getThemes(dto: GetThemesDto) {
    return AtiraApi.get<GetThemesResponseDto>(`/atira-link/theme`, {
      params: dto,
    }).then(({ data }) => data);
  }
}
